import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {ReviewSharedQuestion} from "../../sharedQuestions/ReviewSharedQuestion";
import {IQuestionnaireLogicService} from "../../services/LogicService";

export class ReviewQuestionComponent {

    protected scope:ng.IScope;
    protected timeout:ng.ITimeoutService;
    protected sce:ng.ISCEService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    protected logicService:IQuestionnaireLogicService;

    sharedQuestion:ReviewSharedQuestion;

    previousQuestionJumpCallback:(arg:{id:number})=>void;
    question:IQuestion;

    questionIds:number[]                = [];
    questions:IQuestion[]               = [];
    questionsPreviewComponents:string[] = [];

    private questionsPrefixes:{id:number;prefix:string}[] = [];

    static $inject = ['$scope', '$timeout', '$sce', 'SharedQuestionService', 'SessionService', 'QuestionnaireLogicService'];

    constructor($scope:ng.IScope, $timeout:ng.ITimeoutService, $sce:ng.ISCEService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService, logicService:IQuestionnaireLogicService) {
        this.scope                 = $scope;
        this.timeout               = $timeout;
        this.sce                   = $sce;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
        this.logicService          = logicService;
    }

    $onInit() {
        this.sharedQuestion          = new ReviewSharedQuestion();
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        const questionIds = this.question.meta.questionIds;
        if (questionIds) {
            this.questionIds = questionIds;
        }

        const allQuestions = this.logicService.getPreviousQuestions();
        for (const questionId of this.questionIds) {
            const question = this.questionById(questionId, allQuestions);

            if (question && question.type !== 'review') {
                this.questions.push(question);
                const subQuestions = question.questions;
                if (subQuestions && subQuestions.length > 0) {
                    this.addQuestions(subQuestions);
                }
            }
        }

        if (questionIds.length === 0) {
            this.questions = allQuestions;
        }

        let index = 0;
        for (const question of this.questions) {
            this.questionsPreviewComponents.push('<' + question.type + '-question-preview question="reviewQuestion.questions[' + index + ']" question-id="' + question.id + '" prevent-next-question="true"></' + question.type + '-question-preview>');

            index++;
        }
    }

    title(question:IQuestion) {
        for (const questionPrefix of this.questionsPrefixes) {
            if (questionPrefix.id === question.id) {
                if (question.title.length > 0) {
                    return this.sce.trustAsHtml(questionPrefix.prefix + question.title);   
                }

                return '';
            }
        }

        return this.sce.trustAsHtml('<b>' + question.title + '</b>');
    }

    private addQuestions(questions:IQuestion[], prefix:string = '<span class="dash"></span>') {
        for (const question of questions) {
            this.questions.push(question);
            this.questionsPrefixes.push({
                id    : question.id,
                prefix: prefix
            });

            const subQuestions = question.questions;
            if (subQuestions && subQuestions.length > 0) {
                this.addQuestions(subQuestions, '<span class="dash-spacing"></span>' + prefix);
            }
        }
    }

    private questionById(id:number, questions:IQuestion[]):IQuestion {
        for (let question of questions) {
            if (question.id === id) {
                return question;
            }

            const questions = question.questions;
            if (questions && questions.length) {
                const result = this.questionById(id, questions);
                if (result) {
                    return result;
                }
            }
        }

        return null;
    }

}

app.component('reviewQuestion', {
    templateUrl : 'templates/components/questionTypes/reviewQuestion.html',
    controller  : ReviewQuestionComponent,
    controllerAs: 'reviewQuestion',
    bindings    : {
        question                    : '<',
        nextQuestionCallback        : '&',
        previousQuestionJumpCallback: '&'
    }
});